import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_RESOURCE_FILE_CONFIG} from '../../constants/apiUrls';
import {GET_RESOURCE_FILE_CONFIG_QUERY_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================

export interface ResourceFileConfigResponse {
  fileSizeLimit: number;
  fileNumLimit: number;
  uploadFileTypes: string[];
}

interface Input {
  onSuccess: (data: ResourceFileConfigResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetResourceFileConfig = ({onSuccess, onError}: Input) => {
  const getResourceFileConfig = async () => {
    const res = await axiosClient.get<ResourceFileConfigResponse>(GET_RESOURCE_FILE_CONFIG);
    return res.data;
  };

  return useCustomQuery(GET_RESOURCE_FILE_CONFIG_QUERY_KEY, getResourceFileConfig, {
    onSuccess,
    onError,
  });
};
